<script>
export default {
  props: {
    name: String,
    filters: Object,
    fields: {
      type: Object,
    },
    displayFilter: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    placeholders: {
      type: [String, Object],
    },
    data: Object,
    displayLabels: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    /**
     * @emits filter-change
     * @param {Object} values
     */
    emitFilterChange(values) {
      this.$emit('filter-change', {
        name: this.name,
        values,
      });
    },

    /**
     * @emits labels-change
     * @param {Array} values
     */
    emitLabelsChange(values) {
      this.$emit('labels-change', {
        name: this.name,
        values
      });
    },
  },
}
</script>
